import color from "../../../../constants/color";

const styles = {
  headTitle:{ ml: 2,
    mt: 2, 
    fontWeight: "600",
    fontSize:"18px",
    color:color.text
  },
  subTitle:{
    fontWeight: "500",
    fontSize:"14px",
    color:color.text,
    ml:2
  },
  card:{ backgroundColor: "#fff", 
    margin: 2,
    px: 2,
    borderRadius: "20px",
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root":{
      marginTop:"11px"
    }
  },
  dropDownMenu:{
    fontSize:"14px",
    fontWeight:"400",
    py:2.45
  },
  calender:{
    ".css-6193sp-MuiInputBase-root-MuiOutlinedInput-root":{
      borderRadius:"8px",
      // width:{xs:"18em",sm:"18em",md:"20em",lg:"22em",xl:"25em"}
      width: "100%"
    }
  },
  calenderInput:{
    
    "& .MuiInputBase-input": {
      padding: "8.5px 10px 8.5px 8.5px",
      fontSize:"14px",
      fontWeight:"400",
      marginTop: "0.5em",

    },
    width: "100%",
    marginTop: "0.5em",


  }, 
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
  },
 
  btn: {
    borderRadius: 50,
    textTransform:"none", 
    backgroundColor: "#28AA4A",
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator" :{
      position: "unset", 
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px", 
      marginLeft: "-8px", 
    },

  }
  
};
export default styles;